// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2LfBI","alertIcon":"ConfirmModal_alertIcon__1fBVI"};